// extracted by mini-css-extract-plugin
export var activeDot = "_34-c";
export var buttonContainer = "_34-9";
export var channelButton = "_34-a";
export var clickable = "_34-d";
export var content = "_34-0";
export var contentFull = "_34-2";
export var contentThird = "_34-1";
export var contentWrapper = "_34-7";
export var description = "_34-5";
export var heightShort = "_34-f";
export var image = "_34-3";
export var imageContainer = "_34-4";
export var selectButton = "_34-e";
export var spinnerContainer = "_34-b";
export var titleContent = "_34-8";
export var titleWrapper = "_34-6";